import { useDispatch, useSelector } from "react-redux";
import { setPromptModal } from "../store/actions/app";
import { logout, renewRefreshToken } from "../utilities/oktaUtilities";
import { idleExpiryKey, idleIdlingKey } from "../constants/keys";

export const useIdleListeners = () => {
    const dispatch = useDispatch();
    const idleSettings = useSelector(state => state.app.idleSettings);
    const prompt = useSelector((state) => state.app.promptModal);

    const resetIdleLocalStorage = () => {
        localStorage.setItem(idleExpiryKey, Date.now() + idleSettings.timeout - idleSettings.promptBeforeIdle);
        localStorage.setItem(idleIdlingKey, false);
    };

    const onIdle = (event, api) => {
        if (!prompt.show) {
            localStorage.setItem(idleIdlingKey, true);
            dispatch(setPromptModal(
                true,
                {
                    body: "<strong>You will be signed out due to inactivity.</strong><br/> Time Remaining: $countdown",
                    countdownTo: Date.now() + idleSettings.promptBeforeIdle,
                    title: "Session Expiring Soon",
                    displayIcon: true,
                    buttonText: "Stay Logged In",
                    buttonAction: () => {
                        renewRefreshToken();
                        api.activate();
                    },
                    onClose: () => {
                        dispatch(setPromptModal(false, null));
                        logout();
                    }
                }
            ));
        }
    };

    const onAction = () => {
        resetIdleLocalStorage();
    };

    const onActive = () => {
        resetIdleLocalStorage();
        dispatch(setPromptModal(false, null));
    };

    return {
        onIdle,
        onAction,
        onActive,
    };
};